import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { clsHeaderIcon } from '../helpers/TableHelpers';
import { isAdminDashboard } from 'utils/authScopes';

class AccountsHeader extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onSortChange: PropTypes.func.isRequired,
  }

  onSortChange = (e) => {
    const sort = e.target.dataset.sort;
    const order = this.props.meta.order || 'asc';
    const newOrder = order === 'desc' ? 'asc' : 'desc';
    this.props.onSortChange(sort, newOrder);
  }

  render() {
    const { auth, meta } = this.props;
    return (
      <thead>
        <tr>
          <th data-sort='id' onClick={this.onSortChange}>
            <span data-sort='id' className='o-table-header--sort'>
              {this.props.t('accounts.columns.id')}<i data-sort='id' className={clsHeaderIcon('id', meta)}></i>
            </span>
          </th>
          <th data-sort='first_name' onClick={this.onSortChange}>
            <span data-sort='first_name' className='o-table-header--sort'>
              {this.props.t('accounts.columns.firstName')}<i data-sort='first_name' className={clsHeaderIcon('first_name', meta)}></i>
            </span>
          </th>
          <th data-sort='last_name' onClick={this.onSortChange}>
            <span data-sort='last_name' className='o-table-header--sort'>
              {this.props.t('accounts.columns.lastName')}<i data-sort='last_name' className={clsHeaderIcon('last_name', meta)}></i>
            </span>
          </th>
          <th data-sort='email' onClick={this.onSortChange}>
            <span data-sort='email' className='o-table-header--sort'>
              {this.props.t('accounts.columns.email')}<i data-sort='email' className={clsHeaderIcon('email', meta)}></i>
            </span>
          </th>
          <th data-sort='created_at' onClick={this.onSortChange}>
            <span data-sort='created_at' className='o-table-header--sort'>
              {this.props.t('accounts.columns.createdAt')}<i data-sort='created_at' className={clsHeaderIcon('created_at', meta)}></i>
            </span>
          </th>
          { isAdminDashboard(auth) && <th>{this.props.t('accounts.columns.partner')}</th> }
          <th>{this.props.t('accounts.columns.children')}</th>
          <th data-sort='current_sign_in_at' onClick={this.onSortChange}>
            <span data-sort='current_sign_in_at' className='o-table-header--sort'>
              {this.props.t('accounts.columns.lastAppTouch')}<i data-sort='current_sign_in_at' className={clsHeaderIcon('current_sign_in_at', meta)}></i>
            </span>
          </th>
          <th>{this.props.t('accounts.columns.lastActivity')}</th>
          <th data-sort='archived' onClick={this.onSortChange}>
            <span data-sort='archived' className='o-table-header--sort'>
              {this.props.t('accounts.columns.status')}<i data-sort='archived' className={clsHeaderIcon('archived', meta)}></i>
            </span>
          </th>
          <th>{this.props.t('accounts.columns.totalPlays')}</th>
          <th>{this.props.t('accounts.columns.totalPhotos')}</th>
          {/* <th>Actions</th> */}
        </tr>
      </thead>
    );
  }
}

export default withTranslation()(AccountsHeader);
